/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type sharedMessageHelpers_activePromotion = {
    readonly promotionMeta: {
        readonly customBannerMessage: boolean | null;
        readonly desktopBannerMessage: string | null;
        readonly desktopBannerCta: string | null;
        readonly mobileBannerMessage: string | null;
        readonly mobileBannerCta: string | null;
    } | null;
    readonly " $refType": "sharedMessageHelpers_activePromotion";
};
export type sharedMessageHelpers_activePromotion$data = sharedMessageHelpers_activePromotion;
export type sharedMessageHelpers_activePromotion$key = {
    readonly " $data"?: sharedMessageHelpers_activePromotion$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"sharedMessageHelpers_activePromotion">;
};



const node: ReaderInlineDataFragment = {
    "kind": "InlineDataFragment",
    "name": "sharedMessageHelpers_activePromotion"
} as any;
(node as any).hash = '7c8db323227e2cde65105076d6772d27';
export default node;
